import { create } from "zustand";
import { Application } from './ApplicationInterface';

export interface ApplicationState {
  applications: any;
  setApplications: (applications: Application[]) => void;
  apiStatus: string; //"error" | "idle" | "loading" | "success"
  setApiStatus: (apiStatus: string) => void;
  isFetched: boolean;
  setIsFetched: (isFetched: boolean) => void;
  allApplications: any;
  setAllApplications: (applications: Application[]) => void;
  workflows: any,
  isDriveAppUser: boolean;
}

const _setApplications = (set: any) => (applications: any) =>
  set(() => {
    const workflows = applications
    .filter((app: any) => app?.workflows && app?.workflows?.length > 0)
    .flatMap((app: any) => app?.workflows);
    return {
      applications,
      workflows,
      isDriveAppUser : applications.some((app:any) => app.id === "DMSDRIVE")
    }
});

export const useApplicationStore = create<ApplicationState>((set) => ({
  setApplications: _setApplications(set),
  apiStatus: "",
  setApiStatus: (apiStatus) => set(() => ({ apiStatus })),
  isFetched: false,
  setIsFetched: (isFetched) => set(() => ({ isFetched })),
  allApplications: [],
  setAllApplications: (allApplications) => set(() => ({ allApplications })),
  applications:[],
  workflows:[],
  isDriveAppUser: false,
}));
